import { render, staticRenderFns } from "./umfragen-widget.vue?vue&type=template&id=f511d6bc&scoped=true"
import script from "./umfragen-widget.vue?vue&type=script&lang=js"
export * from "./umfragen-widget.vue?vue&type=script&lang=js"
import style0 from "./umfragen-widget.vue?vue&type=style&index=0&id=f511d6bc&prod&scoped=true&lang=css"
import style1 from "./umfragen-widget.vue?vue&type=style&index=1&id=f511d6bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f511d6bc",
  null
  
)

export default component.exports